import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";

export const NOVIDADES_LAST_SEEN_KEY = "novidades_last_seen";

const TYPE_LABEL = {
  feature: "Novo",
  improvement: "Melhoria",
  fix: "Correção",
  security: "Segurança"
};

const TYPE_COLOR = {
  feature: "primary",
  improvement: "info",
  fix: "default",
  security: "warning"
};

const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

const ChangeCard = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(2),
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(1.5),
  borderRadius: 14,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  transition: "box-shadow 0.2s, transform 0.2s",
  "&:hover": {
    boxShadow: "0 8px 24px rgba(11,95,255,0.10)",
    transform: "translateY(-1px)"
  }
}));

const IconBubble = styled(Box)(({ theme }) => ({
  width: 52,
  height: 52,
  flexShrink: 0,
  borderRadius: 14,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 28,
  background: theme.palette.action.hover
}));

const Novidades = () => {
  const [loading, setLoading] = useState(true);
  const [releases, setReleases] = useState([]);

  useEffect(() => {
    const fetchNovidades = async () => {
      try {
        const { data } = await api.get("/novidades");
        const list = data?.releases || [];
        setReleases(list);
        const latest = list[0]?.date;
        if (latest) {
          localStorage.setItem(NOVIDADES_LAST_SEEN_KEY, latest);
          window.dispatchEvent(new CustomEvent("novidades:seen"));
        }
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchNovidades();
  }, []);

  return (
    <MainContainer>
      <MainHeader>
        <Title>Novidades da plataforma</Title>
      </MainHeader>

      {/* MainContainer trava a rolagem (overflowY: hidden) e cada página declara a sua;
          esta não declarava, então o conteúdo era cortado sem barra de rolagem. */}
      <Box sx={{ p: { xs: 1, sm: 2 }, maxWidth: 860, flex: 1, overflowY: "auto" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress />
          </Box>
        ) : releases.length === 0 ? (
          <Typography color="textSecondary" sx={{ py: 6, textAlign: "center" }}>
            Nenhuma novidade por aqui ainda. Volte em breve!
          </Typography>
        ) : (
          releases.map((rel) => (
            <Box key={rel.version} sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                <Typography variant="subtitle2" color="textSecondary">
                  {formatDate(rel.date)}
                </Typography>
                <Box sx={{ flex: 1, height: "1px", bgcolor: "divider" }} />
              </Box>

              {rel.changes.map((c) => (
                <ChangeCard key={c.id}>
                  <IconBubble>{c.icon || "✨"}</IconBubble>
                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5, flexWrap: "wrap" }}>
                      <Typography variant="h6" sx={{ fontSize: "1.05rem", fontWeight: 700 }}>
                        {c.title_cliente}
                      </Typography>
                      <Chip
                        size="small"
                        label={TYPE_LABEL[c.type] || "Novo"}
                        color={TYPE_COLOR[c.type] || "primary"}
                        variant={c.type === "fix" ? "outlined" : "filled"}
                      />
                    </Box>
                    <Typography variant="body2" color="textSecondary">
                      {c.desc_cliente}
                    </Typography>
                  </Box>
                </ChangeCard>
              ))}
            </Box>
          ))
        )}
      </Box>
    </MainContainer>
  );
};

export default Novidades;
